import { Image } from "@chakra-ui/react";
import homepage from "../images/Homepage.png";
import courses from "../images/Courses.png";
import reports from "../images/Reports.webp";

export default function Functionalities() {
  return (
    <section className="section" id="section--1">
      <div className="section__title">
        <h3 className="section__header">Pregled funkcionalnosti platforme</h3>
      </div>
      <div className="features">
        <Image
          src={homepage}
          alt="SafeCrafts home page"
          className="features__img"
          loading="lazy"
        />
        <div className="features__feature">
          <h5 className="features__header">E-učenje</h5>
          <p>Pametna interaktivna platforma za učenje</p>
        </div>
        <div className="features__feature">
          <h5 className="features__header">Simulacija napada</h5>
          <p>
            Mogućnost odabira učesnika za simulaciju napada u određenom
            vremenskom periodu
          </p>
        </div>
        <Image
          src={courses}
          alt="SafeCrafts courses page"
          className="features__img"
          loading="lazy"
        />
        <Image
          src={reports}
          alt="SafeCrafts reports page"
          className="features__img features__img__last"
          loading="lazy"
        />
        <div className="features__feature">
          <h5 className="features__header">Izveštavanje</h5>
          <p>
            Pregledaj izveštaje o napretku polaznika na platformi i analizi
            reakcije na simulaciju napada
          </p>
        </div>
      </div>
    </section>
  );
}
